import { travel, axiosConfig } from 'api';
import { AxiosResponse } from 'axios';

import { TravelType } from 'models/enums/travelType';
import { RequestTripType } from 'models/enums/tripType';
import { Response } from 'models/response';
import { TravelDetails } from 'models/travelDetails';
import { TravelRequested } from 'models/travelRequested';
import { TravelStatus } from 'models/travelStatus';

export interface TravelRequestPayload {
  userId: string;
  initDate?: string;
  endDate?: string;
  page?: number;
  maxItemsPerPage?: number;
  travelType?: TravelType;
  distanceRestriction?: RequestTripType;
  destinationCode?: string;
  destinationType?: 'country' | 'city';
  travelItineraryId?: string;
  travelStatus?: TravelStatus;
}

export interface TravelRequestResponse {
  data: {
    travels: TravelRequested[];
    total: number;
  };
}

export const getTravelsRequested = async ({
  userId,
  initDate,
  endDate,
  page = 1,
  maxItemsPerPage = 10,
  travelType,
  distanceRestriction,
  destinationCode,
  destinationType,
  travelItineraryId,
  travelStatus,
}: TravelRequestPayload) => {
  const payload = {
    userId,
    initDate,
    endDate,
    page,
    maxItemsPerPage,
    travelType,
    distanceRestriction,
    destinationCode,
    destinationType,
    travelItineraryId,
    travelStatus,
  };
  return travel.post<TravelRequestResponse>('Travels/GetTravelsByUserV2', payload);
};

export const getTravelDetail = async (travelId: string, sessionToken?: string) => {
  const data = {
    travelId,
    sessionToken,
  };

  return travel.get<Response<TravelDetails>>('Travels/GetTravelDetailById', {
    params: data,
    ...axiosConfig,
  });
};

export const cancelPendingTravel = async (
  travelId: string,
  userId: string,
  sessionToken: string,
): Promise<AxiosResponse<Response<any>>> =>
  await travel
    .put(`CustomerSupport/Travel/Cancel/${travelId}`, {
      userId: userId,
      sessionToken: sessionToken,
      reason: 'no-reason-selected',
    })
    .catch((error) => {
      throw error;
    });
